import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const generalOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.SETTINGS_GENERAL,
    steps: [
        {
            id: "gen-welcome",
            title: "Configurações Gerais",
            description:
                "Aqui você cria e gerencia variáveis de configuração globais da plataforma. Estes valores são usados pelo backend e pelos apps.",
            position: "center",
        },
        {
            id: "gen-list",
            title: "Lista de Configurações",
            description:
                "Cada linha mostra o nome da variável, seu valor atual e ações para editar ou excluir.",
            targetId: "general-config-list",
            position: "bottom",
        },
        {
            id: "gen-add",
            title: "Adicionar Configuração",
            description:
                "Clique para criar uma nova variável. Variáveis comuns: dados da empresa (CNPJ, razão social), base de nota fiscal, configurações de e-mail.",
            targetId: "general-add-btn",
            position: "left",
        },
        {
            id: "gen-edit",
            title: "Editar Configuração",
            description:
                "Em cada card de configuração, use o botão 'Editar' para alterar o valor ou 'Excluir' para removê-la. As alterações são salvas no backend imediatamente.",
            position: "center",
        },
        {
            id: "gen-company",
            title: "Perfil da Empresa",
            description:
                "Configure aqui as variáveis de perfil: COMPANY_NAME, COMPANY_CNPJ, COMPANY_ADDRESS, INVOICE_SERIES e outros dados de nota fiscal.",
            position: "center",
        },
    ],
};
